// TODO: Remove frontend date/time formatting in this folder once the backend fully returns display-ready values (MARCC-570).

import React, { useRef, RefObject } from "react";
import FormInput, { FormProps } from "../input/FormInput";
import { TextDateInput } from "./datetime.style";
import {
  addTimezoneInfo,
  formatDateTime,
  getConstraint,
  getConstraintDateString,
  getMinSupportedDatetimeLocal,
  SF_MAX_DATETIME,
} from "./methods";
import "../../EstimatedDateTime/estimatedDateTime.css";

interface Iprops extends FormProps {
  handleChange: (fieldName: string, value: any) => void;
}

const DateTimeInput = (props: Iprops) => {
  const {
    constraint,
    incidentCreationDate,
    incidentDateTime,
    handleChange,
    name,
    onBlur,
    disabled,
    toggleBoxValue,
  } = props;

  const textFieldRef: RefObject<HTMLInputElement> = useRef(null);

  function handleDateChange(e: React.ChangeEvent<HTMLInputElement>): void {
    if (!e.target.value) {
      return;
    }
    handleChange(name as string, addTimezoneInfo(e.target.value));
  }

  const handleDoubleClick = () => {
    textFieldRef.current && textFieldRef.current.showPicker();
  };

  const updatedConstraint =
    constraint &&
    getConstraint(constraint, incidentCreationDate, incidentDateTime);

  const formattedValue = props.value ? formatDateTime(props.value) : "";

  // Toggle on = estimated timestamp; the picker stays enabled and both states
  // write Incident_Date_Time__c. Only the cue and Unknown_Date_and_Time__c differ.
  const inputClassName = `mr-2 ${toggleBoxValue ? "estimated-input" : ""}`.trim();

  // Always bound the picker to the supported range — a 5-years-back lower bound
  // and Salesforce's hard year-4000 upper bound — so a mistyped year like "0026"
  // is clamped on the spinner and flagged invalid by the browser. A business
  // constraint (e.g. "before the incident date") tightens the bound where
  // present, but never loosens it past the supported range, so the picker can't
  // offer a value the shared Yup guardrail (isWithinSupportedDateRange) would
  // reject. All values are zero-padded YYYY-MM-DDTHH:mm, so string comparison is
  // chronological. See docs/datetime-fields.md.
  const supportedMin = getMinSupportedDatetimeLocal();
  const constraintMin =
    updatedConstraint && getConstraintDateString(updatedConstraint, "min");
  const constraintMax =
    updatedConstraint && getConstraintDateString(updatedConstraint, "max");

  // Lower bound: the later of (business min, supported min).
  const minAttr =
    constraintMin && constraintMin > supportedMin ? constraintMin : supportedMin;
  // Upper bound: the earlier of (business max, Salesforce max).
  const maxAttr =
    constraintMax && constraintMax < SF_MAX_DATETIME
      ? constraintMax
      : SF_MAX_DATETIME;

  return (
    <FormInput
      {...props}
      name={name}
      setFieldValue={handleChange}
    >
      <div className="flex w-full">
        <TextDateInput
          data-testid={`datetime-input-${name}`}
          ref={textFieldRef}
          key={name}
          // data-testid="datetime-picker"
          type={"datetime-local"}
          name={name}
          className={inputClassName}
          onChange={handleDateChange}
          onDoubleClick={handleDoubleClick}
          onBlur={onBlur}
          value={formattedValue || ""}
          disabled={disabled}
          max={maxAttr}
          min={minAttr}
        />
      </div>
    </FormInput>
  );
};

export default DateTimeInput;
